import { Components, Theme } from '@mui/material';

export const tabStyles: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.customGrey.dark
    })
  }
};
